import React from "react";

import rewards0 from "@pages/learn/assets/basics/basic1.png";
import rewards1 from "@pages/learn/assets/basics/basic2.png";
import rewards2 from "@pages/learn/assets/basics/basic3.png";
import rewards3 from "@pages/learn/assets/basics/basic4.png";
import rewards4 from "@pages/learn/assets/basics/basic5.png";
import rewards5 from "@pages/learn/assets/basics/basic6.png";
import rewards6 from "@pages/learn/assets/basics/basic7.png";
import rewards7 from "@pages/learn/assets/basics/basic8.png";
import rewards8 from "@pages/learn/assets/basics/basic9.png";
import rewards9 from "@pages/learn/assets/basics/basic10.png";

const rewardsheight = "225px";
const text = "incomplete puzzle";

export const BASIC_REWARDS: React.ReactNode[] = [
  <img
    className="image"
    src={rewards0}
    height={rewardsheight}
    alt="empty puzzle"
  ></img>,
  <img
    className="image"
    src={rewards1}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards2}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards3}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards4}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards5}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards6}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards7}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards8}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards9}
    height={rewardsheight}
    alt={text}
  ></img>,
];
